
import { defineComponent, SetupContext, PropType, ref } from "vue";
import SelectingIngredientListItem from "@/components/common/SelectingIngredientListItem.vue";
import { SelectingIngredientListDataItem } from "@/types/common";
import NativeClient from "@/client/native-client";
  
export default defineComponent({
  name: "SelectingIngredientList",
  components: { SelectingIngredientListItem },
  props: {
    /**
     * 食材の分類名
     */
    categoryTitle: {
      type: String,
      default: null
    },
    /**
     * 食材リストの配列
     */
    ingredientList: {
      type: Array as PropType<SelectingIngredientListDataItem[]>,
      default: null
    }
  },
  setup(props, context: SetupContext) {
    NativeClient.sendDebugLog("SelectingIngredientList setup categoryTitle = " + props.categoryTitle + ", ingredientList = " + JSON.stringify(props.ingredientList));

    const ingredientArray = ref(Array<SelectingIngredientListDataItem>());

    const updateIngredientList = (selectedId: number | null, name: string, isSelect: boolean) => {
      NativeClient.sendDebugLog("SelectingIngredientList updateIngredientList");
      if (ingredientArray.value.length == 0) {
        NativeClient.sendDebugLog("SelectingIngredientList ingredientList null");
        ingredientArray.value = Array<SelectingIngredientListDataItem>();
        return;
      }

      // ingredientArrayをコピーする
      const ingredientInfoArray = Array<SelectingIngredientListDataItem>()
      for (const ingredientItem of ingredientArray.value) {
        const ingredientInfo = new SelectingIngredientListDataItem();
        ingredientInfo.id = ingredientItem.id;
        ingredientInfo.imageUrl = ingredientItem.imageUrl;
        ingredientInfo.name = ingredientItem.name;
        ingredientInfo.isSelect = ingredientItem.isSelect;
        ingredientInfo.isShowButton = ingredientItem.isShowButton;
        if (selectedId == ingredientItem.id && name == ingredientItem.name) {
          NativeClient.sendDebugLog("SelectingIngredientList ingredientArray id = " + ingredientItem.id + ", isSelect =  " + isSelect); 
          ingredientInfo.isSelect = isSelect;
        }
        ingredientInfoArray.push(ingredientInfo);
      }
      ingredientArray.value = ingredientInfoArray;
      NativeClient.sendDebugLog("SelectingIngredientList ingredientArray =  " + JSON.stringify(ingredientInfoArray));         
    };

    // 初期値
    const initialIngredientArray = () => {
      const ingredientInfoArray = Array<SelectingIngredientListDataItem>()
      for (const ingredientItem of props.ingredientList) {
        const ingredientInfo = new SelectingIngredientListDataItem();
        ingredientInfo.id = ingredientItem.id;
        ingredientInfo.imageUrl = ingredientItem.imageUrl;
        ingredientInfo.name = ingredientItem.name;
        ingredientInfo.isSelect = ingredientItem.isSelect;
        ingredientInfo.isShowButton = ingredientItem.isShowButton;
        ingredientInfoArray.push(ingredientInfo);
      }
      ingredientArray.value = ingredientInfoArray;
    };

    initialIngredientArray();

    const selectIngredient = (id: number | null, name: string, isSelect: boolean) => {
      NativeClient.sendDebugLog("SelectingIngredientList selectIngredient id = " + id + ", isSelect = " + isSelect);
      updateIngredientList(id, name, isSelect);
      context.emit("on-select", id, name, isSelect);
    };

    const clickButton = (id: number | null, name: string) => {
      NativeClient.sendDebugLog("SelectingIngredientList clickButton id = " + id + " name = " + name);
      context.emit("click-button", id, name);
    };

    return {
      ingredientArray,
      selectIngredient,
      clickButton
    };
  }
});
